import User from "models/User";

export enum DataStatus {
    READY = 1,
    PROGRESS = 2,
    ALL_COMPLETE = 3
}

export const LoadingSequences = [
    "Initializing Adaya",

    "Retrieving Shopify Store Revenue",
    "Retrieving Shopify Store Orders",
    "Retrieving Shopify Store Returns",

    "Retrieving Meta Account Ad Spend",

    "Calculating MER",
    "Calculating MER Last 7 Days",
    "Calculating MER Last 30 Days",
    "Calculating MER Month to Date",
    "Calculating MER Quarter to Date",
    "Calculating MER Year to Date",

    "Retrieving Adaya Tracked Sessions",
    "Retrieving Adaya Tracked Add to Carts",
    "Retrieving Adaya Tracked Purchases",

    "Retrieving Adaya Campaigns",
    "Retrieving Adaya Adsets",
    "Retrieving Adaya Ads",

    "Retrieving Meta Campaigns",
    "Retrieving Meta Adsets",
    "Retrieving Meta Ads",

    "Compiling Quantum Ads Manager",
    "Compiling Quantum Ads Manager Today",
    "Compiling Quantum Ads Manager Yesterday",
    "Compiling Quantum Ads Manager Last 7 Days",

    "Calculating Campaign Velocity Last 7 Days",
    "Initializing ML Prediction",
    "Linear Probability Increase",
    "Linear Probability Decrease",
    "Finalizing Predictive ROAS",
    "Compiling Recommended Actions",

    "Retrieving User Journeys",
    "Retrieving User Journey Sessions",
    "Retrieving User Journey Click Events",
    "Retrieving User Journey Pageviews",
    "Retrieving User Journey Purchase Attribution",
    "Compiling Purchase Journeys",

    "Initializing User Goals",
    "Retrieving User MER Goal",
    "Retrieving User ROAS Goal",
    "Retrieving User Revenue Goal",
    "Retrieving User Ad Spend Goal",
    "Retrieving User AOV Goal",
    "Retrieving User Cost Per Purchase Goal",

    "Analyzing Goal Pace MER",
    "Analyzing Goal Pace ROAS",
    "Analyzing Goal Pace Revenue",
    "Analyzing Goal Pace Ad Spend",
    "Analyzing Goal Pace AOV",
    "Analyzing Goal Pace Cost Per Purchase",

    "Generating Performance Velocity ",
    "Generating Performance Trends ",
    "Generating Performance Insights",
    "Generating Performance Recommendations",

    "Confirming Purchase Data Sent to Meta API",

    "Final Adaya Initialization",

    "Loading", // Keep this as the last so it asks as a general loading/delay signal.
];

export default interface IDataProvider {

    // When a module's data unit is updated, this will signal to the DataService.
    public updateData(user: User, updateCallback?);

}
